import LFModal from './LFModal';

export default LFModal;
